import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null,
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SET_NULL(state) {
            state.value = null;
        },
        SELECT_PLATAFORMA(state, item) {
            state.value = item;
        },
        SET_PLATAFORMAS(state, items = []) {
            state.items = items;
        },
        ADD_PLATAFORMA(state, oneItem) {
            state.items.push(oneItem);
        },
        DELETE_PLATAFORMA(state, Id) {
            const ind = state.items.findIndex(plataforma => plataforma.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_PLATAFORMA(state, { Id, plataforma }) {
            const ind = state.items.findIndex(plataforma => plataforma.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, plataforma);
            }
        }
    },

    actions: {
        setPlataformaNull({ commit }) {
            return (commit('SET_NULL'), true)
        },

        selectPlataforma({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item === data);
            return exitsItem ? (commit('SELECT_PLATAFORMA', data), true) : false;
        },

        // first param is context object
        setPlataformas({ commit }, data) {
            commit('SET_PLATAFORMAS', data);
            return true;
        },
        addPlataforma({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_PLATAFORMA', data), true) : false;
        },

        deletePlataforma({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_PLATAFORMA', id), true) : false;
        },

        editPlataforma({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return exitsItem ? (commit('EDIT_PLATAFORMA', data), true) : false;
        },

    }
};
